export default {
      id: "trailer-usage",
      viewBox: "0 0 37 19",
      url: __webpack_public_path__ + "img/icons.svg#trailer",
      toString: function () {
        return this.url;
      }
    }